import { getDataMapper, mapField } from "@/shared";

export const mapReferralFromServer = getDataMapper({
    bonus: mapField("bonus", Number),
    promocode: mapField("promocode", String),
    attractedCount: mapField("attracted_count", Number),
});
